export interface WindowErrors {
  error: string;
  flashError: string;
  flashSuccess: string;
}

/**
 * Emburse login is enabled by default, but can be disabled by either:
 * local storage key `emburse_login` is set to 'false'.
 * Or `useEmburseLogin` query parameter is explicitly 'false'
 *
 * @param searchUri - The URL search string (e.g., `?useEmburseLogin=false`).
 * @returns `true` if Emburse login should be enabled; otherwise `false`.
 */
export function emburseLoginEnabled(searchUri: string) {
  // if login disabled by local storage
  if (localStorage && localStorage['emburse_login'] === 'false') {
    return false;
  }

  // if no local storage or search params, default to emburse login enabled
  if (!URLSearchParams || !searchUri) {
    return true;
  }

  let searchParams = new URLSearchParams(searchUri);

  // only return false if useEmburseLogin is explicitly set to false, otherwise default to true
  if (searchParams.get('useEmburseLogin') === 'false') {
    return false;
  }

  return true;
}

export function getCompanyIdFromUrl(searchUri: string) {
  if (!URLSearchParams || !searchUri) {
    return null;
  }

  const searchParams = new URLSearchParams(searchUri);
  if (!searchParams) {
    return null;
  }

  return searchParams.get('company_id');
}
